import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { iconForField } from '../../../../common/custom/icon-library';

export default class EmailField extends Component {
  validate = (value) => {
    const { field, isConstructorForm } = this.props;
    const { required } = field;
    let error;
    if (!isConstructorForm && required && !value) {
      error = 'This field is required';
    } else if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value)) {
      error = 'Invalid email address';
    }
    return error;
  };

  render() {
    const { field, isConstructorForm } = this.props;
    return (
      <>
        {/* <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <div className="form-group">
            <div className="input-group">
              <div className="input-group-prepend" title={field.fieldTitle['en']}>
                <span className="input-group-text">
                  <i className={`wb ${iconForField(field.type)}`}></i>
                  <span className="required">
                    {field.required && !isConstructorForm ? ' *' : ''}
                  </span>
                </span>
              </div> */}
        <Field
          type="email"
          name={field.fieldName}
          className="form-control form-control-sm"
          validate={this.validate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          title={field.fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
        {/* </div>
          </div>
        </div> */}
      </>
    );
  }
}
